import { styled } from '@storybook/theming';
import { styles } from '@storybook/design-system';
import { htmlFormatting } from '../../styles/html-formatting';
import { TRIGGER_CLASS } from './ImageLightbox';

const { color } = styles;

export const PostBody = styled.div`
  ${htmlFormatting}
  display: flex;
  flex-direction: column;
  align-items: center;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  ul,
  ol,
  dl,
  pre,
  blockquote,
  hr,
  details,
  .footnotes {
    min-width: 100%;
  }

  /* Buttons the lightbox wraps around images; they must not change layout */
  .${TRIGGER_CLASS} {
    display: block;
    max-width: 100%;
    margin: 0 auto;
    padding: 0;
    border: 0;
    background: none;
    font: inherit;
    color: inherit;
    cursor: zoom-in;

    &:focus-visible {
      outline: 2px solid ${color.secondary};
      outline-offset: 4px;
    }
  }

  .kg-gallery-image .${TRIGGER_CLASS} {
    width: 100%;
    height: 100%;
  }

  .kg-width-full .${TRIGGER_CLASS} {
    max-width: 100vw;
  }
`;
